import SubQuotation from './sub-quotation';

export default SubQuotation;